import {
    Component,
    Input,
    Output,
    ContentChildren,
    HostListener,
    EventEmitter,
    AfterContentInit
} from '@angular/core';

import { MyTab } from './mytab';

@Component({
    selector: 'mytabset',
    template: `
    <section class="tab-set">
      <ul
        class="nav nav-tabs"
        [class.nav-pills]="vertical"
        [class.nav-tabs]="!vertical">
        <li
          *ngFor="let tab of tabs"
          class="nav-item"
          [class.active]="tab.active">
          <a
            href="javascript:void(0);"
            (click)="tabClicked(tab)"
            class="nav-link"
            [class.active]="tab.active"
            [class.disabled]="tab.disabled">
            <span>{{tab.title}}</span>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <ng-content select=".tab-holder"></ng-content>
      </div>
    </section>
  `
})
export class MyTabset implements AfterContentInit {

    @Input() vertical;
    @Output() onSelect = new EventEmitter();
    @ContentChildren(MyTab) tabs;
    currentTabIndex: number;

    ngAfterContentInit() {
        setTimeout(() => {
            const tabs = this.tabs.toArray();
            const actives = this.tabs.filter(t => { return t.active });

            if (actives.length > 1) {
                console.error(`Multiple active tabs set 'active'`);
            } else if (!actives.length && tabs.length) {
                tabs[0].active = true;
                this.onSelect.emit(tabs[0]);
                this.currentTabIndex = 0;
            }
        });
    }

    tabClicked(tab) {
        const tabs = this.tabs.toArray();

        tabs.forEach(tab => tab.active = false);
        tab.active = true;

        this.onSelect.emit(tab);
    }

    onPrevious() {
        const tabs = this.tabs.toArray();
        //drecrement current tab index by 1
        let tab = tabs[this.currentTabIndex--];
        //invoke tab click action
        this.tabClicked(tab);
    }

    onNext() {
        const tabs = this.tabs.toArray();
        //increment current tab index by 1
        let tab = tabs[this.currentTabIndex++];
        //invoke tab click action
        this.tabClicked(tab);
    }
}

export const TAB_COMPONENTS = [
    MyTabset,
    MyTab
];


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/directives/mytabset.ts